import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  debounce,
  map,
  Observable,
  of,
  Subject,
  switchMap,
  timer,
} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalLoaderService {
  private readonly isLoading$ = new BehaviorSubject<boolean>(false);

  private readonly change$ = new Subject<boolean>();

  constructor() {
    this.change$
      .pipe(
        switchMap((value) =>
          value ? of(true) : timer(500).pipe(map(() => false))
        )
      )
      .subscribe((value) => this.isLoading$.next(value));
  }

  public get isLoading(): boolean {
    return this.isLoading$.getValue();
  }

  public get subscription(): Observable<boolean> {
    return this.isLoading$.asObservable();
  }

  public show(): void {
    this.change$.next(true);
  }

  public hide(): void {
    this.change$.next(false);
  }
}
